// userAxios.js
import axios from "axios";
import { setupCache } from "axios-cache-interceptor";

const base = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "https://acwadam.org",
  timeout: 30000,
});

const userAxios = setupCache(base, {
  ttl: 1000 * 60 * 20, // 5 minutes
  interpretHeader: false,
});

userAxios.interceptors.response.use((response) => {
  return response;
});

export default userAxios;
